<div class="registaration">
    <!-- Confetti Container -->
    <div #confetti class="confetti-container"></div>

    <div class="r-header">
        <img src="assets/images/logo-dark.svg" alt="">
    </div>
    <div class="sidebar">
        <img src="assets/images/logo2.svg" class="logo" alt="Luqta">
        <h2>
            Secure your subscription and manage everything in one place.
        </h2>
        <img src="assets/images/r-sidebar-v.svg" class="r-sidebar-v animated" alt="">
    </div>
    <div class="form-body">
        <div class="successfully-payment" *ngIf="status === 'verifying'" role="status" aria-live="polite">
            <h3 class="title">
                Confirming your payment…
            </h3>
        </div>

        <div class="successfully-payment" *ngIf="status === 'paid'">
            <img src="assets/images/check222.png" class="check animated-zoom" alt="">
            <h3 class="title">
                Payment Successful
            </h3>
            <button class="btn btn-primary btn-md w-100 mb-2" (click)="goToHomepage()">
                {{ isLoggedIn ? 'Go to Dashboard' : 'Login' }}
            </button>
            <button class="btn btn-primary-outline btn-md w-100 mb-2" *ngIf="isLoggedIn" (click)="goToContests()">
                Go to Campaigns
            </button>
            <button class="btn btn-secondary-outline btn-md w-100" [disabled]="!isPaymentVerified" (click)="goToInvoice()">
                View Invoice
            </button>
        </div>

        <div class="successfully-payment" *ngIf="status === 'pending' || status === 'failed'" role="alert">
            <img src="assets/images/cross.png" class="check animated-zoom" alt="">
            <h3 class="title">
                {{ status === 'pending' ? 'Payment not completed' : 'Payment could not be confirmed' }}
            </h3>
            <p class="mb-3">{{ failureMessage }}</p>
            <button class="btn btn-primary btn-md w-100 mb-2" (click)="retry()">
                Check again
            </button>
            <button class="btn btn-primary-outline btn-md w-100" (click)="goToHomepage()">
                {{ isLoggedIn ? 'Go to Dashboard' : 'Login' }}
            </button>
        </div>
    </div>
</div>
